// magnifier above the finger while a corner is dragged (finger does not hide the wall edge)
const D = 120, Z = 2.5;
export function MoistLoupe({ src, p, box, pts }) {
  if (!p || !box) return null;
  const px = p[0] * box.width, py = p[1] * box.height, up = py > D + 30;
  const left = Math.max(0, Math.min(box.width - D, px - D / 2)), top = up ? py - D - 30 : Math.min(py + 30, Math.max(0, box.height - D));
  const sx = D / Z / box.width, sy = D / Z / box.height;
  return (
    <div className="mo-loupe" data-testid="moist-loupe" style={{ left, top, width: D, height: D }}>
      <svg viewBox={`${p[0] - sx / 2} ${p[1] - sy / 2} ${sx} ${sy}`} preserveAspectRatio="none" width={D} height={D}>
        <image href={src} x={0} y={0} width={1} height={1} preserveAspectRatio="none" />
        {pts && <polygon points={pts.map((q) => q.join(',')).join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} vectorEffect="non-scaling-stroke" />}
      </svg>
      <i className="mo-loupe-x" />
    </div>
  );
}
